module.exports = __webpack_public_path__ + "img/9.3b9de194.png";